module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "OT"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "CON4",
    attrs: {
      "id": "toc1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text1#toc_marker-1"
    }
  }, [_vm._v("Preface to the Third Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "CON4",
    attrs: {
      "id": "toc2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text2#toc_marker-2"
    }
  }, [_vm._v("Preface to the Second Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "CON4",
    attrs: {
      "id": "toc3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text3#toc_marker-3"
    }
  }, [_vm._v("Preface to the First Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "CON4",
    attrs: {
      "id": "toc4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text4#toc_marker-4"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "CON4",
    attrs: {
      "id": "toc5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text5#toc_marker-5"
    }
  }, [_vm._v("Sources Frequently Cited")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text6#toc_marker-6"
    }
  }, [_vm._v("1. The Task of Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text6#toc_marker-6-1"
    }
  }, [_vm._v("Theology as Faith Seeking Understanding")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text6#toc_marker-6-2"
    }
  }, [_vm._v("The Questionable Nature of Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text6#toc_marker-6-3"
    }
  }, [_vm._v("The Questions of Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text6#toc_marker-6-4"
    }
  }, [_vm._v("Methods of Asking Theological Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc126"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text6#toc_marker-6-5"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text7#toc_marker-7"
    }
  }, [_vm._v("2. The Meaning of Revelation")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text7#toc_marker-7-1"
    }
  }, [_vm._v("What Is Revelation?")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text7#toc_marker-7-2"
    }
  }, [_vm._v("God Hidden and Revealed")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text7#toc_marker-7-3"
    }
  }, [_vm._v("Revelation as Objective and Subjective")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text7#toc_marker-7-4"
    }
  }, [_vm._v("General and Special Revelation")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text7#toc_marker-7-5"
    }
  }, [_vm._v("Models of Revelation")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text7#toc_marker-7-6"
    }
  }, [_vm._v("Revelation as God’s Self-­Disclosure Narrated in Scripture")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text7#toc_marker-7-7"
    }
  }, [_vm._v("Revelation, Scripture, and Church")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc127"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text7#toc_marker-7-8"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text8#toc_marker-8"
    }
  }, [_vm._v("3. The Authority of Scripture")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text8#toc_marker-8-1"
    }
  }, [_vm._v("The Problem of Authority in Modern Culture")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text8#toc_marker-8-2"
    }
  }, [_vm._v("Inadequate Approaches to the Authority of Scripture")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text8#toc_marker-8-3"
    }
  }, [_vm._v("The Indispensability of Scripture in Relating Us, by the Powerof the Spirit, to the Living God Revealed in Jesus Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text8#toc_marker-8-4"
    }
  }, [_vm._v("Principles of the Interpretation of Scripture")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc128"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text8#toc_marker-8-5"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text9#toc_marker-9"
    }
  }, [_vm._v("4. The Triune God")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text9#toc_marker-9-1"
    }
  }, [_vm._v("The Problem of God in Modern Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text9#toc_marker-9-2"
    }
  }, [_vm._v("The Biblical Roots of the Doctrine of the Trinity")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text9#toc_marker-9-3"
    }
  }, [_vm._v("Classical Trinitarian Doctrine")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text9#toc_marker-9-4"
    }
  }, [_vm._v("Distortions in the Doctrine of God")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text9#toc_marker-9-5"
    }
  }, [_vm._v("Restatement of the Meaning of the Doctrine of the Trinity")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text9#toc_marker-9-6"
    }
  }, [_vm._v("The Attributes of God")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text9#toc_marker-9-7"
    }
  }, [_vm._v("The Electing Grace of God")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc129"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text9#toc_marker-9-8"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text10#toc_marker-10"
    }
  }, [_vm._v("5. The Good Creation")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text10#toc_marker-10-1"
    }
  }, [_vm._v("Christian Faith and the Ecological Crisis")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text10#toc_marker-10-2"
    }
  }, [_vm._v("Rereading the Scriptural Witness on Creation")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc35"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text10#toc_marker-10-3"
    }
  }, [_vm._v("Rethinking the Themes of the Doctrine of Creation")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text10#toc_marker-10-4"
    }
  }, [_vm._v("Trinity, Creation, and Ecology")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc37"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text10#toc_marker-10-5"
    }
  }, [_vm._v("Models of Creation")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc38"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text10#toc_marker-10-6"
    }
  }, [_vm._v("The Doctrine of Creation and Modern Science")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc130"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text10#toc_marker-10-7"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc39"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text11#toc_marker-11"
    }
  }, [_vm._v("6. The Providence of God and the Mystery of Evil")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc40"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text11#toc_marker-11-1"
    }
  }, [_vm._v("Belief in Providence and the Reality of Evil")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc41"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text11#toc_marker-11-2"
    }
  }, [_vm._v("Providence and Evil in the Theological Tradition")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc42"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text11#toc_marker-11-3"
    }
  }, [_vm._v("Rethinking Providence and Evil")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc43"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text11#toc_marker-11-4"
    }
  }, [_vm._v("Recent Theodicies")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc44"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text11#toc_marker-11-5"
    }
  }, [_vm._v("The Triune God and Human Suffering")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc45"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text11#toc_marker-11-6"
    }
  }, [_vm._v("Providence, Prayer, Practice")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc131"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text11#toc_marker-11-7"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc46"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text12#toc_marker-12"
    }
  }, [_vm._v("7. Humanity as Creature, Sinner,and New Being in Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc47"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text12#toc_marker-12-1"
    }
  }, [_vm._v("Interpretations of “Image of God”")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc48"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text12#toc_marker-12-2"
    }
  }, [_vm._v("Created Humanity")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc49"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text12#toc_marker-12-3"
    }
  }, [_vm._v("Fallen Humanity")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc50"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text12#toc_marker-12-4"
    }
  }, [_vm._v("The Meaning of Original Sin and of Death as Enemy")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc51"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text12#toc_marker-12-5"
    }
  }, [_vm._v("New Humanity in Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc132"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text12#toc_marker-12-6"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc52"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text13#toc_marker-13"
    }
  }, [_vm._v("8. The Person and Work of Jesus Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc53"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text13#toc_marker-13-1"
    }
  }, [_vm._v("Problems in Christology")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc54"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text13#toc_marker-13-2"
    }
  }, [_vm._v("Principles of Christology")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc55"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text13#toc_marker-13-3"
    }
  }, [_vm._v("Patristic Christology")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc56"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text13#toc_marker-13-4"
    }
  }, [_vm._v("Rethinking Classical Affirmations of the Person of Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc57"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text13#toc_marker-13-5"
    }
  }, [_vm._v("Rethinking Classical Interpretations of the Work of Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc58"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text13#toc_marker-13-6"
    }
  }, [_vm._v("Violence and the Cross")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc59"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text13#toc_marker-13-7"
    }
  }, [_vm._v("Dimensions of the Resurrection of Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc133"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text13#toc_marker-13-8"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc60"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text14#toc_marker-14"
    }
  }, [_vm._v("9. Confessing Jesus Christ in Context")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc61"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text14#toc_marker-14-1"
    }
  }, [_vm._v("The Particularity and Universality of the Gospel")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc62"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text14#toc_marker-14-2"
    }
  }, [_vm._v("Latin American Christology")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc63"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text14#toc_marker-14-3"
    }
  }, [_vm._v("African American Christology")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc64"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text14#toc_marker-14-4"
    }
  }, [_vm._v("Feminist, Womanist, and Mujerista Christologies")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc65"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text14#toc_marker-14-5"
    }
  }, [_vm._v("Hispanic Christology")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc66"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text14#toc_marker-14-6"
    }
  }, [_vm._v("Asian American Christology")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc67"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text14#toc_marker-14-7"
    }
  }, [_vm._v("The Local and the Global in Christology")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc134"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text14#toc_marker-14-8"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc68"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text15#toc_marker-15"
    }
  }, [_vm._v("10. The Holy Spirit and the Christian Life")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc69"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text15#toc_marker-15-1"
    }
  }, [_vm._v("Neglect and Recovery of the Doctrine of the Holy Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc70"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text15#toc_marker-15-2"
    }
  }, [_vm._v("A Sketch of a Theology of the Holy Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc71"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text15#toc_marker-15-3"
    }
  }, [_vm._v("The Christian Life: Justification")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc72"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text15#toc_marker-15-4"
    }
  }, [_vm._v("The Christian Life: Sanctification")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc73"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text15#toc_marker-15-5"
    }
  }, [_vm._v("The Christian Life: Vocation")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc135"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text15#toc_marker-15-6"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc74"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text16#toc_marker-16"
    }
  }, [_vm._v("11. The New Community")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc75"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text16#toc_marker-16-1"
    }
  }, [_vm._v("The Problem of the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc76"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text16#toc_marker-16-2"
    }
  }, [_vm._v("New Testament Images of the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc77"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text16#toc_marker-16-3"
    }
  }, [_vm._v("Critique of Current Models of the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc78"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text16#toc_marker-16-4"
    }
  }, [_vm._v("The Church and the Call to Communion")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc79"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text16#toc_marker-16-5"
    }
  }, [_vm._v("The Church and the Call to Mission")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc80"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text16#toc_marker-16-6"
    }
  }, [_vm._v("Classical Marks of the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc136"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text16#toc_marker-16-7"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc81"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text17#toc_marker-17"
    }
  }, [_vm._v("12. Proclamation, Sacraments, and Ministry")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc82"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text17#toc_marker-17-1"
    }
  }, [_vm._v("Proclamation of the Word")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc83"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text17#toc_marker-17-2"
    }
  }, [_vm._v("What Are Sacraments?")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc84"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text17#toc_marker-17-3"
    }
  }, [_vm._v("The Meaning of Baptism")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc85"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text17#toc_marker-17-4"
    }
  }, [_vm._v("The Meaning of the Lord’s Supper")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc86"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text17#toc_marker-17-5"
    }
  }, [_vm._v("Baptism, the Lord’s Supper, and Ethics")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc87"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text17#toc_marker-17-6"
    }
  }, [_vm._v("The Meaning of an Ordained Ministry")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc137"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text17#toc_marker-17-7"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc88"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text18#toc_marker-18"
    }
  }, [_vm._v("13. The Finality of Jesus Christand Religious Pluralism")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc89"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text18#toc_marker-18-1"
    }
  }, [_vm._v("The Ambiguity of Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc90"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text18#toc_marker-18-2"
    }
  }, [_vm._v("Types of Christian Theologies of the Religions")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc91"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text18#toc_marker-18-3"
    }
  }, [_vm._v("Toward a Trinitarian Theology of the Religions")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc92"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text18#toc_marker-18-4"
    }
  }, [_vm._v("Salvation in Other Religions?")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc93"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text18#toc_marker-18-5"
    }
  }, [_vm._v("Christians and Jews")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc94"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text18#toc_marker-18-6"
    }
  }, [_vm._v("Christians and Muslims")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc95"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text18#toc_marker-18-7"
    }
  }, [_vm._v("Witness to Jesus Christ in a Religiously Pluralistic World")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc138"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text18#toc_marker-18-8"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc96"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text19#toc_marker-19"
    }
  }, [_vm._v("14. Christian Hope")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc97"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text19#toc_marker-19-1"
    }
  }, [_vm._v("The Crisis of Hope in an Age of Terrorism")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc98"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text19#toc_marker-19-2"
    }
  }, [_vm._v("Principles for Interpreting Christian Hope")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc99"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text19#toc_marker-19-3"
    }
  }, [_vm._v("Classical Symbols of Christian Hope")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc100"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text19#toc_marker-19-4"
    }
  }, [_vm._v("Eschatology and Ethics")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc139"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text19#toc_marker-19-5"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "CON3",
    attrs: {
      "id": "toc101"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text20#toc_marker-20"
    }
  }, [_vm._v("APPENDIX A: Natural Theology: A Dialogue")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc102"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text20#toc_marker-20-1"
    }
  }, [_vm._v("An Unusual Meeting")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc103"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text20#toc_marker-20-2"
    }
  }, [_vm._v("Tillich and Barth")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc104"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text20#toc_marker-20-3"
    }
  }, [_vm._v("Ecumenist and Barth")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc105"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text20#toc_marker-20-4"
    }
  }, [_vm._v("Rahner and Barth")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc106"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text20#toc_marker-20-5"
    }
  }, [_vm._v("A Final Exchange")])]), _vm._v(" "), _c('p', {
    staticClass: "CON3",
    attrs: {
      "id": "toc107"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text21#toc_marker-21"
    }
  }, [_vm._v("APPENDIX B: The Resurrection: A Dialogue")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc108"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text21#toc_marker-21-1"
    }
  }, [_vm._v("Resurrection and Historical Reason")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc109"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text21#toc_marker-21-2"
    }
  }, [_vm._v("Mostly Barth and Bultmann")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc110"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text21#toc_marker-21-3"
    }
  }, [_vm._v("Mostly Pannenbergian")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc111"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text21#toc_marker-21-4"
    }
  }, [_vm._v("Mostly Moltmannian")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc112"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text21#toc_marker-21-5"
    }
  }, [_vm._v("Summations")])]), _vm._v(" "), _c('p', {
    staticClass: "CON3",
    attrs: {
      "id": "toc113"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text22#toc_marker-22"
    }
  }, [_vm._v("APPENDIX C: Political Theology: A Dialogue")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc114"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text22#toc_marker-22-1"
    }
  }, [_vm._v("A Gathering of Political Theologians")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc115"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text22#toc_marker-22-2"
    }
  }, [_vm._v("Niebuhr and Barth")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc116"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text22#toc_marker-22-3"
    }
  }, [_vm._v("Liberationist and Niebuhr")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc117"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text22#toc_marker-22-4"
    }
  }, [_vm._v("Feminist and Liberationist")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc118"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text22#toc_marker-22-5"
    }
  }, [_vm._v("Prayer and Politics")])]), _vm._v(" "), _c('p', {
    staticClass: "CON3",
    attrs: {
      "id": "toc119"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text23#toc_marker-23"
    }
  }, [_vm._v("APPENDIX D: Atheism: A Dialogue")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc120"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text23#toc_marker-23-1"
    }
  }, [_vm._v("The Death of God")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc121"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text23#toc_marker-23-2"
    }
  }, [_vm._v("A New Humanism?")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc122"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text23#toc_marker-23-3"
    }
  }, [_vm._v("The Humanity of God")])]), _vm._v(" "), _c('p', {
    staticClass: "CON3",
    attrs: {
      "id": "toc123"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text24#toc_marker-24"
    }
  }, [_vm._v("APPENDIX E: A Glossary of Theological Terms")])]), _vm._v(" "), _c('p', {
    staticClass: "CON4",
    attrs: {
      "id": "toc124"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text25#toc_marker-25"
    }
  }, [_vm._v("Index of Names and Subjects")])]), _vm._v(" "), _c('p', {
    staticClass: "CON4",
    attrs: {
      "id": "toc125"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Migliore_Faith_Seeking_Understanding_text26#toc_marker-26"
    }
  }, [_vm._v("Index of Scripture References")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b439491","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 63
// module chunks = 0